document.addEventListener('click', function (event) {
  var dropdowns = document.querySelectorAll('.bhub-dropdown-menu')
  dropdowns.forEach(function (dropdown) {
    if (!dropdown.contains(event.target)) {
      dropdown.removeAttribute('open')
    }
  })
})
